import apiClient from '../apiClient';
import { POST_TRANSPORTATION_UNIT_URL } from '../apiUrl';

const postTransportationUnitApi = data => {
  return apiClient.post(POST_TRANSPORTATION_UNIT_URL, data);
};

export default postTransportationUnitApi;
